var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, Button, Card, CardContent, Checkbox, FormControlLabel, Link, Typography, } from "@mui/material";
import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useAddExistingTeamToLeague, useRetrieveAddableTeams, useRetrieveLeague, } from "../api/LeagueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
export var AddExistingTeamsToLeague = function () {
    var leagueId = useNumericParams().id;
    var navigate = useNavigate();
    var _a = __read(useState([]), 2), selectedTeamIds = _a[0], setSelectedTeamIds = _a[1];
    var _b = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), userLeaguePermissions = _b.data, userLeaguePermissionsIsLoading = _b.isLoading, userLeaguePermissionsError = _b.error;
    var _c = useRetrieveLeague({ id: leagueId }), league = _c.data, leagueIsLoading = _c.isLoading, leagueError = _c.error;
    var _d = useRetrieveAddableTeams({
        leagueId: leagueId,
        enabled: userLeaguePermissions === null || userLeaguePermissions === void 0 ? void 0 : userLeaguePermissions.canModify,
    }), _e = _d.data, addableTeamsData = _e === void 0 ? [] : _e, addableTeamsIsLoading = _d.isLoading, addableTeamsError = _d.error;
    // Sort teams by name
    var addableTeams = __spreadArray([], __read(addableTeamsData), false).sort(function (a, b) {
        return a.name.localeCompare(b.name);
    });
    var addTeamsMutation = useAddExistingTeamToLeague({
        leagueId: leagueId,
        onMutate: function () {
            // Optional: Show loading state
        },
        onSuccess: function () {
            navigate("/leagues/".concat(leagueId, "/"));
        },
        onError: function (error) {
            console.error("Failed to add teams:", error);
        },
    });
    var _f = (userLeaguePermissions || {}).canModify, canModify = _f === void 0 ? false : _f;
    if (userLeaguePermissionsIsLoading ||
        leagueIsLoading ||
        addableTeamsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userLeaguePermissionsError) {
        return _jsx(ErrorView, { error: userLeaguePermissionsError });
    }
    if (leagueError) {
        return _jsx(ErrorView, { error: leagueError });
    }
    if (addableTeamsError) {
        return _jsx(ErrorView, { error: addableTeamsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    var handleTeamToggle = function (teamId) {
        setSelectedTeamIds(function (prev) {
            return prev.includes(teamId)
                ? prev.filter(function (id) { return id !== teamId; })
                : __spreadArray(__spreadArray([], __read(prev), false), [teamId], false);
        });
    };
    var handleSelectAll = function () {
        if (selectedTeamIds.length === addableTeams.length) {
            setSelectedTeamIds([]);
        }
        else {
            setSelectedTeamIds(addableTeams.map(function (team) { return team.id; }));
        }
    };
    var handleSubmit = function () {
        if (selectedTeamIds.length > 0) {
            addTeamsMutation.mutate({ teamIds: selectedTeamIds });
        }
    };
    return (_jsxs(Box, { sx: { maxWidth: 800, mx: "auto", p: 3, mb: 6 }, children: [_jsxs(Typography, { variant: "h4", sx: { textAlign: "center", mb: 1, fontWeight: 600 }, children: ["Add Teams to", " ", _jsx(Link, { component: RouterLink, to: "/leagues/".concat(leagueId, "/"), underline: "hover", children: league.name })] }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { textAlign: "center", mb: 4 }, children: "Select the teams you want to add to this league" }), addableTeams.length === 0 ? (_jsxs(Card, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Typography, { variant: "h6", sx: { mb: 2, color: "text.secondary" }, children: "No Teams Available" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "You don't have any teams available to add to this league. All your teams are either already in this league or you don't have any teams yet." }), _jsx(Button, { component: RouterLink, to: "/leagues/".concat(leagueId, "/teams/create/"), variant: "contained", sx: { mr: 2 }, children: "Create New Team" }), _jsx(Button, { component: RouterLink, to: "/leagues/".concat(leagueId, "/"), variant: "outlined", children: "Back to League" })] })) : (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: {
                            mb: 3,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }, children: [_jsxs(Typography, { variant: "h6", children: [selectedTeamIds.length, " of ", addableTeams.length, " teams selected"] }), _jsx(Button, { onClick: handleSelectAll, variant: "outlined", size: "small", children: selectedTeamIds.length === addableTeams.length
                                    ? "Deselect All"
                                    : "Select All" })] }), _jsx(Box, { sx: { mb: 4 }, children: addableTeams.map(function (team) {
                            var _a;
                            return (_jsx(Card, { sx: {
                                    mb: 2,
                                    border: selectedTeamIds.includes(team.id)
                                        ? "2px solid"
                                        : "1px solid",
                                    borderColor: selectedTeamIds.includes(team.id)
                                        ? "primary.main"
                                        : "grey.300",
                                    bgcolor: selectedTeamIds.includes(team.id)
                                        ? "primary.50"
                                        : "background.paper",
                                    cursor: "pointer",
                                }, onClick: function () { return handleTeamToggle(team.id); }, children: _jsxs(CardContent, { sx: { display: "flex", alignItems: "center", gap: 2, py: 2 }, children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedTeamIds.includes(team.id), onChange: function () { return handleTeamToggle(team.id); }, onClick: function (e) { return e.stopPropagation(); } }), label: "", sx: { m: 0 }, onClick: function (e) { return e.stopPropagation(); } }), _jsx(Avatar, { alt: team.name, src: team.logo || undefined, sx: { width: 56, height: 56 }, children: (_a = team.name.match(/\b(\w)/g)) === null || _a === void 0 ? void 0 : _a.join("") }), _jsxs(Box, { sx: { flex: 1 }, children: [_jsx(Typography, { variant: "h6", children: team.name }), team.nickname && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: team.nickname })), team.establishedYear && (_jsxs(Typography, { variant: "caption", color: "text.secondary", children: ["EST \u2022 ", team.establishedYear] }))] })] }) }, team.id));
                        }) }), _jsxs(Box, { sx: { display: "flex", justifyContent: "center", gap: 2 }, children: [_jsx(Button, { onClick: handleSubmit, disabled: selectedTeamIds.length === 0 || addTeamsMutation.isLoading, variant: "contained", size: "large", sx: { px: 4 }, children: addTeamsMutation.isLoading
                                    ? "Adding Teams..."
                                    : "Add ".concat(selectedTeamIds.length, " Team").concat(selectedTeamIds.length !== 1 ? "s" : "") }), _jsx(Button, { component: RouterLink, to: "/leagues/".concat(leagueId, "/add-team/"), variant: "outlined", size: "large", disabled: addTeamsMutation.isLoading, children: "Back" })] })] }))] }));
};
